// icons
import logoFacebook from '@iconify/icons-carbon/logo-facebook';
import logoInstagram from '@iconify/icons-carbon/logo-instagram';
import logoLinkedin from '@iconify/icons-carbon/logo-linkedin';
import { Button, ButtonProps, IconButton, IconButtonProps, Link, Stack } from '@mui/material';
// @mui
import { alpha } from '@mui/material/styles';
// @types
import { SocialLinks } from '../@types/socials';
//
import Iconify from './Iconify';

// ----------------------------------------------------------------------

type Props = IconButtonProps & ButtonProps;

interface SocialsButtonProps extends Props {
  simple?: boolean;
  initialColor?: boolean;
  links?: SocialLinks;
}

export default function SocialsButton({
  initialColor = false,
  simple = true,
  links = {
    linkedin: 'https://www.linkedin.com/company/bergen-elektro-automasjon-as',
    facebook: 'https://www.facebook.com/bergenelektroautomasjon/',
    instagram: 'https://www.instagram.com/bergen_elektro_automasjon/',
  },
  sx,
  ...other
}: SocialsButtonProps) {
  const SOCIALS = [
    {
      name: 'FaceBook',
      icon: logoFacebook,
      socialColor: '#1877F2',
      path: links.facebook || '#facebook-link',
    },
    {
      name: 'Instagram',
      icon: logoInstagram,
      socialColor: '#E02D69',
      path: links.instagram || '#instagram-link',
    },
    {
      name: 'Linkedin',
      icon: logoLinkedin,
      socialColor: '#007EBB',
      path: links.linkedin || '#linkedin-link',
    },
  ];

  return (
    <Stack direction="row" flexWrap="wrap" alignItems="center">
      {SOCIALS.map((social) => {
        const { name, icon, path, socialColor } = social;
        return simple ? (
          <Link title={name + " sosial media konto"} key={name} href={path}>
            <IconButton
              aria-label={name}
              color="inherit"
              sx={{
                ...(initialColor && {
                  color: socialColor,
                  '&:hover': {
                    bgcolor: alpha(socialColor, 0.08),
                  },
                }),
                ...sx,
              }}
              {...other}
            >
              <Iconify icon={icon} sx={{ width: 20, height: 20 }} />
            </IconButton>
          </Link>
        ) : (
          <Button
            aria-label={name}
            key={name}
            href={path}
            color="inherit"
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              flexShrink: 0,
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha(socialColor, 0.08),
                },
              }),
              ...sx,
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
